var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"socials my-4"},_vm._l((_vm.socials),function(value,key){return _c('a',{key:key,staticClass:"socials__link",class:key,attrs:{"rel":"nofollow noopener","target":"_blank","href":value,"title":key},on:{"click":function($event){return _vm.openNewWindow(value)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }